<div class="form-label">{{(config.label)|translate:{currency: authService.store?.currency} }}</div>
<div class="price-rage">
  @if(minControl){
  <app-input [config]="minConfig" [customFormControl]="minControl" ngDefaultControl>
  </app-input>
  }
  @if(maxControl){
  <app-input [config]="maxConfig" [customFormControl]="maxControl" ngDefaultControl>
  </app-input>
  }
</div>
